import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import MapIcon from "@mui/icons-material/Map";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export const ESTADO_DESCARTADO = 340;

export const ORIGENES = {
  PEDIDO_NUEVO: "Pedido nuevo",
  TELEFONISTAS: "Telefonistas",
  HOJA_RUTA: "Hoja de ruta",
  SIN_ORIGEN: "Sin origen"
};

// color: chip MUI de la tabla / hex: tarjetas y barra de distribución
export const ORIGEN_CONFIG = {
  [ORIGENES.PEDIDO_NUEVO]: { color: "primary", hex: "#1a73e8", Icon: PhoneAndroidIcon },
  [ORIGENES.TELEFONISTAS]: { color: "warning", hex: "#f9a825", Icon: HeadsetMicIcon },
  [ORIGENES.HOJA_RUTA]: { color: "success", hex: "#34a853", Icon: MapIcon },
  [ORIGENES.SIN_ORIGEN]: { color: "default", hex: "#9aa0a6", Icon: HelpOutlineIcon }
};

export const TABLE_INITIAL_STATE = {
  density: "compact",
  pagination: { pageIndex: 0, pageSize: 50 },
  columnPinning: { right: ["mrt-row-actions"] },
  grouping: ["fecha_format", "sucursal_cliente"]
};
